// Text scaling ///////////////////////////////////
// When escape key is press, fade out text scaling menu
jQuery(function ($) {
  function closeTextScalingMenu(e) {
    console.log("e.key", e.key);

    if (e.key === "Escape") {
      closeTextScalingMenuForReal();
    }
  }

  // Fade out text scaling menu
  function closeTextScalingMenuForReal() {
    // $('.text-scaling-menu').attr('aria-expanded', false);
    $(".button-lettergrootte").attr("aria-expanded", false);
    $(".text-scaling-menu").fadeOut();
    document.removeEventListener("keyup", closeTextScalingMenu);
  }

  $(".button-lettergrootte").on("click", function () {
    if ($(".button-lettergrootte").attr("aria-expanded") === "true") {
      closeTextScalingMenuForReal();
      console.log("true");
    } else {
      console.log("false");
      $(".button-lettergrootte").attr("aria-expanded", true);
      $(".text-scaling-menu").fadeIn();
      document.addEventListener("keyup", closeTextScalingMenu);
    }
  });

  $(".text-scaling-menu").on("click", function () {
    closeTextScalingMenuForReal();
  });

  $(".button-lettergrootte").on("keyup", function (e) {
    if (e.key === "Escape") {
      // $('.text-scaling-menu').attr('aria-expanded', false);
      $(".button-lettergrootte").attr("aria-expanded", false);
      $(".text-scaling-menu").fadeOut();
    }
  });

  const scaleSize = localStorage.scaleText;
  const textScaleSizes = ["100", "150", "200"];

  $(".toggle-scale-text").removeClass("active");

  textScaleSizes.forEach((size) => {
    document.documentElement.classList.remove(`scale-text-${size}`);
  });

  document.documentElement.classList.add(`scale-text-${scaleSize}`);

  $(`.toggle-scale-text[data-scale-text='${scaleSize}']`).addClass("active");

  $(".toggle-scale-text").on("click", function (e) {
    e.preventDefault();
    const elm = $(this);
    const scaleSize = elm.data("scale-text");

    $(".toggle-scale-text").removeClass("active");

    textScaleSizes.forEach((size) => {
      document.documentElement.classList.remove(`scale-text-${size}`);
    });

    document.documentElement.classList.add(`scale-text-${scaleSize}`);
    localStorage.scaleText = scaleSize;

    $(`.toggle-scale-text[data-scale-text='${scaleSize}']`).addClass("active");

    if (mobilePanel.hasClass("active")) {
      closeMobileMenu();
    }
    // $("body").removeClass("freeze");
  });

  // Text scaling END ///////////////////////////////////

  let focusOutOfTextScalingButton = false;

  $("div, a, button").on("focusout", function (e) {
    if ($(this).hasClass("toggle-scale-text")) {
      focusOutOfTextScalingButton = true;
    }
  });

  $("div, a, button").on("focusin", function (e) {
    const found1 = e.target.classList.value.indexOf("toggle-scale-text");
    const found2 = e.target.classList.value.indexOf("button-lettergrootte");

    if (found1 < 0 && found2 < 0 && focusOutOfTextScalingButton === true) {
      closeTextScalingMenuForReal();
      focusOutOfTextScalingButton = false;
    }
  });
});
